<template>
  <Modal v-model:show="show" @update:show="onUpdateShow" :show-close="true" class="product-viewer-qr-modal">
    <div class="qr-scan-text">Scan this QR code using the camera on your iOS device.</div>
    <canvas height="300" width="300" class="product-viewer-qr" ref="canvas"></canvas>
    <div class="ar-supported-browsers"><span class="bold">Note:</span> AR requires a device running iPadOS or iOS 12 or later.</div>
  </Modal>
</template>
<script>
import { onMounted, ref, watch, nextTick } from 'vue';
import Modal from '@/pixel/components/Modal.vue';
import QRCode from 'qrcode';

export default {
  components: {
    Modal
  },

  props: {
    url: {
      type: String,
      default: null
    },
    show: {
      type: Boolean,
      default: false
    }
  },

  setup(props, ctx) {
    const qrCode = ref(null);
    const canvas = ref(null);

    watch(() => props.url, () => {
      if(canvas.value) {
        buildQRCode(canvas.value);
      }
    });

    watch(() => props.show, () => {
      nextTick(() => {
        if(canvas.value && props.show) {
          buildQRCode(canvas.value);
        }
      });
    });

    function buildQRCode(canvas) {
      return new Promise((resolve, reject) => {
        if(props.url) {
          QRCode.toCanvas(canvas, props.url, {
            width: 300
          }, function (err, url) {
            if(err) {
              reject(err);
            } else {
              resolve();
            }
          });
        }
        resolve();
      });
    }

    function onUpdateShow(val) {
      ctx.emit('update:show', val);
    }

    onMounted(() => {
      buildQRCode(canvas.value);
    });

    return {
      qrCode,
      canvas,
      onUpdateShow
    };
  }
}
</script>
<style lang="postcss">
.product-viewer-qr {
  width: 300px;
  height: 300px;
}

.qr-scan-text {
  max-width: 300px;
  margin-left: auto;
  margin-right: auto;
  font-size: var(--font-size-24);
  text-align: center;
}

.product-viewer-qr-modal.modal {
  .body {
    padding: var(--space-10) var(--space-10) var(--space-6) var(--space-10);
    text-align: center;
  }
}

.ar-supported-browsers {
  max-width: 300px;
  margin-left: auto;
  margin-right: auto;
}

</style>